<template>
    <div>   
        <v-divider></v-divider>  
        <mbs-page-tab 
            :items="MY_LINKS"/>   
        <v-divider></v-divider>  
        <v-divider></v-divider>  
        <v-divider></v-divider>  
        <v-container grid-list-xl> 
            <v-layout align-center="" justify-center="">
                <v-col sm="12" cols="12"> 
                    <v-card :min-height="vsh/2" >   
                        <mbs-item-manager
                            :table_title="'Manage Measurements'"
                            :table_title_icon="'mdi-scale'"
                            :add_vertical_lines="true"
                            :row_click="true"
                            v-model="input"
                            :table_tabs="TABLE_TABS"
                            :top_label="false"
                            :name_items="NAME_ITEMS"
                            :name_item="NAME_ITEM+'--'"
                            :value_items="VALUE_ITEMS"
                            :value_item="VALUE_ITEM"
                            :field_items="DATA.FIELDS.items"
                            :header_items="HEADER_ITEMS"
                            :header_items2="HEADER_ITEMS2"
                            :data_items="ItemWithMeasurements"  
                            :is_joined="true"  
                            :path_item="PATH_ITEM"  
                            :select_items="DataSource"  
                            :total_item_values="TOTAL_ITEM_VALUES"  

                            :table_actions="TableActions" 
                            @SELECT_TABLE_ACTION="TABLE_ACTION"
                            @SELECT_ITEM_ACTION="ITEM_ACTION"
                        />  
                    </v-card>
                    <br><br>
                </v-col>  
            </v-layout>
        </v-container>  

        <!-- //DIALOGS -->
        <div>
            <div v-if="ADDING_ITEM">
                <mbs-item-manager 
                    :show="false" 
                    :add_item_action="ADDING_ITEM.add_item_action"
                    :name_items="ADDING_ITEM.names"
                    :name_item="ADDING_ITEM.name"
                    :value_items="ADDING_ITEM.values"
                    :value_item="ADDING_ITEM.value"
                    :field_items="ADDING_ITEM.fields"   
                    :path_item="ADDING_ITEM.path"  
                    :select_items="Selectors"  
                    @ADDED="ADDED" 
                /> 
            </div>

            <!-- ADD ITEM CHILD MEASUREMENT-->
            <div v-if="dialog_add_measurement">
                <v-dialog 
                    v-model="dialog_add_measurement"
                    scrollable   
                    :persistent="false" :overlay="false"
                    max-width="700px"
                    transition="dialog-transition" >
                    <form @submit.prevent="ADD_ITEM_MEASUREMENT(input)"> 
                        <v-card  exact>
                            <v-card-title class="primary white--text"  >
                                Add Item Child Measurement 
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="dialog_add_measurement = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text>
                                    <div class="pa-5">
                                        <mbs-input-fields
                                            v-model="input"
                                            :name_items="NAME_ITEMS"
                                            :name_item="NAME_ITEM"
                                            :value_items="VALUE_ITEMS"
                                            :value_item="VALUE_ITEM"
                                            :field_items="DATA.FIELDS.item_measurement"
                                            :select_items="DataSource" 
                                            />  
                                    </div>
                                </v-card-text>
                                <v-card-actions class="pa-5"> 
                                    <v-btn class="px-9" large @click="dialog_add_measurement = false" color="primary" >Cancel</v-btn>
                                    <v-flex > 
                                        <v-btn large width="100%" type="submit" color="secondary" class="ml-2">Add Item</v-btn>
                                    </v-flex>
                                </v-card-actions>
                        </v-card> 
                    </form> 
                </v-dialog>  
            </div>
            
            <!-- UPDATE STOCK LEVEL ITEM-->
            <div v-if="dialog_update_measurement">
                <v-dialog 
                    v-model="dialog_update_measurement"
                    scrollable   
                    :persistent="false" :overlay="false"
                    max-width="700px"
                    transition="dialog-transition" >
                    <form @submit.prevent="UPDATE_MEASUREMENT(input)"> 
                        <v-card  exact>
                            <v-card-title class="primary white--text"  >
                                Update Item Measurement
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="dialog_update_measurement = false"><v-icon>mdi-close</v-icon></v-btn>
                            </v-card-title>
                            <v-card-text>
                                    <div class="pa-5">
                                        <mbs-input-fields
                                            v-model="input"
                                            :name_items="NAME_ITEMS"
                                            :name_item="NAME_ITEM"
                                            :value_items="VALUE_ITEMS"
                                            :value_item="VALUE_ITEM"
                                            :field_items="DATA.FIELDS.item_measurement"
                                            :select_items="DataSource" 
                                            />  
                                    </div>
                                </v-card-text>
                                <v-card-actions class="pa-5"> 
                                    <v-btn class="px-9" large @click="dialog_update_measurement = false" color="primary" >Cancel</v-btn>
                                    <v-flex > 
                                        <v-btn large width="100%" type="submit" color="secondary" class="ml-2">Update Item</v-btn>
                                    </v-flex>
                                </v-card-actions>
                        </v-card> 
                    </form> 
                </v-dialog>  
            </div>
        </div>
    </div> 
</template>

<script> 
    import DATA from '../../../../plugins/DATA'
    import {mapState,mapGetters } from "vuex"
    import { mdiFormatListGroupPlus } from '@mdi/js';
    import { mdiProgressTag } from '@mdi/js';
    let PAGE_NAME = DATA.ITEMS.ITEM_DEPARTMENTS.values    
    export default {
        name:PAGE_NAME, 
        props:['id','stock_level_code'], 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
                input:{},
                field_updating:false,
                dialog_add_measurement:false,
                dialog_update_measurement:false,
                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
                ADDING_ITEM:null, 
                
                DATA:DATA,
                TOTAL_ITEM_VALUES:[ 
                    // {name:'Closing Stock (QTY)',value:'number_quantity',show_value:"number_quantity"},
                    // {name:'Total Cost',value:'number_total_cost',show_value:'number_total_cost_',money:true},
                ], 
            }
        },
        created() {
            try { 
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try { 
                this.MBS.actions.header({
                    show:true,
                    type:'subToolbar', 
                    images:null,
                    color:'black',
                    height:"300",
                    opacity:'0.1'
                }) 
                this.FEEDBACKS(1000)  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("manage",2,true) 
                return thisLinks
            }, 
            PATH_ITEM(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true) 
                return path
            },
            /////////
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()],
                Brands: state=> state.items[(DATA.ITEMS.BRANDS.values).toUpperCase()],
                Manufacturers: state=> state.items[(DATA.ITEMS.MANUFACTURERS.values).toUpperCase()], 
                TaxGroups: state=> state.app[(DATA.ITEMS.TAX_GROUPS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                SelectedCompany: state=> state.items["SELECTED_COMPANY"],   
                MeasuringUnits: state=> state.app['MEASURING_UNITS'], 
                MeasuringOptions: state=> state.app['MEASURING_TYPES'], 
            }),  
            StockOutletsData(){ 
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets 
                return items
            }, 
            ItemsData(){ 
                let Items = this.Items
                let JoinedItems = this.JoinedItems
                let CalculatedItems = this.CalculatedItems 
                if (JoinedItems) {
                    return JoinedItems
                } 
                return Items
            },
            InventoryItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })  
                return filtered
            },
            NotParentItems(){ 
                const items = this.ItemsData 
                const filtered = items?.filter(item=>{
                    const parent = item.item_type_key == "parent"
                    return  !parent
                })  
                return filtered
            },
            ItemWithMeasurements(){ 
                const items = this.NotParentItems 
                const filtered = items?.filter(item=>{
                    const container_measuring_units_key = item.container_measuring_units_key
                    return  container_measuring_units_key?true:false
                })  
                return filtered
            }, 
            ItemWithoutMeasurements(){ 
                const items = this.NotParentItems 
                const filtered = items?.filter(item=>{
                    const container_measuring_units_key = item.container_measuring_units_key
                    return  container_measuring_units_key?false:true
                })  
                return filtered
            }, 

            DataSource(){ 
                let Outlets = this.StockOutletsData 
                let Items = this.field_updating?this.ItemWithMeasurements  :this.ItemWithoutMeasurements  
                let ItemCategories = this.ItemCategories
                let Brands = this.Brands
                let Manufacturers = this.Manufacturers
                let TaxGroups = this.TaxGroups
                let MeasuringUnits = this.MeasuringUnits
                let MeasuringOptions = this.MeasuringOptions 
                return{
                    Outlets: Outlets,
                    Items: Items,
                    ItemCategories: ItemCategories,
                    Brands: Brands,
                    Manufacturers: Manufacturers, 
                    TaxGroups: TaxGroups, 
                    MeasuringUnits: MeasuringUnits, 
                    MeasuringOptions: MeasuringOptions,  
                }
            },
             
            TABLE_TABS(){
                const options = this.MeasuringOptions
                let items = [
                    {name:"All Items",show_if:(this_,item)=>{  
                            return !item.item_kits
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}
                ]
                if (options) {
                    options.forEach(option => {
                        items.push({
                            name:option.name,show_if:(this_,item)=>{  
                                return item?.container_measuring_units_option_key == option?.key
                            },
                            indicator:{
                                color:'primary',
                                value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                            }
                        })
                    });
                }
                
                return items
            },
            HEADER_ITEMS(){
                const input = this.input
              

                let headers = [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:false},  
                    {id:0,name:"",value:'icon_image',color:"",size:35,tile:true,show:false},   
                    {id:0,name:"Barcode",value:"code_",align:"center",show:true},   
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Category",value:"category_name",show:true}, 
                    {id:0,name:"Category Code",value:"category_code",show:false}, 
                    {id:0,name:"Brand",value:"brand_name",show:false}, 
                    {id:0,name:"Brand Code",value:"brand_code",show:false}, 
                    {id:0,name:"Manufacturers",value:"manufacturer_name",show:false}, 
                    {id:0,name:"Manufacturer Code",value:"manufacturer_code",show:false}, 
                    
                    {id:0,name:"Cost Price",value:"cost_price_",class:' b ',show:false}, 
                    {id:0,name:"Retail Price",value:"retail_price_",class:' b ',show:false}, 
                    {id:0,name:"Wholesale Price",value:"wholesale_price",class:' b ',show:false}, 

                    
                        
                    {id:0,name:"Empty",value:"container_empty_size",align:"center",show:true}, 
                    {id:0,name:"Full",value:"container_full_size",align:"center",show:true}, 
                    {id:0,name:"Number",value:"container_child_number",align:"center",show:true}, 
                    {id:0,name:"Measurement",value:"container_measuring_units_key",align:"center",show:true}, 
                    {id:0,name:"Measurement Option",value:"container_measuring_units_option_key",align:"center",show:true}, 

                    {id:0,name:"Tax Group",value:"tax_group_name",align:"center",show:false}, 
                    {id:0,name:"Tax Group Code",value:"tax_group_code",align:"center",show:false}, 
                    {id:0,name:"action",align:"right",show:false,item:[  
                        {name:"Update Measurement",action:"update_item_measurement",icon:"mdi-pencil"},
                        {name:"Remove Measurement",action:"remove_item_measurement",icon:"mdi-delete"},
                    ]}, 
                ] 
                return headers
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:true},  
                    {id:0,name:"Barcode",value:"code",align:"center",show:true},      
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Category",value:"category_code",show:true}, 
                    {id:0,name:"Brand",value:"brand_code",show:true}, 
                    {id:0,name:"Cost",value:"cost_price",show:true}, 
                    {id:0,name:"Retail",value:"retail_price",show:true}, 
                    {id:0,name:"Wholesale",value:"wholesale_price",show:true}, 
                    {id:0,name:"Tax",value:"tax",show:true}, 
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },  
            TableActions(){ 
                let action = [{type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"}]
                if (true) {
                    action = [
                        {type:"action",btn:true,icon:"mdi-refresh",action:"refresh",color:"secondary", outlined:false,  text:"Refresh"},
                        {type:"action",btn:true,icon:"mdi-plus-box-multiple",action:"add_item_measurement",color:"secondary", outlined:false,  text:"Add Measurement"},
                    ]
                }
                let actions = [
                    ...action,     
                    {type:"action",icon:mdiProgressTag,action:"sync_stock_levels",color:"secondary", outlined:false,  text:"Sync Stock Level"},  
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ]
                return  actions
            },
        },
        methods: {  
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action("Item Data","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "add_item_measurement") {
                        this.ON_ADD_ITEM_MEASUREMENT()
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ITEM_ACTION(action,item,option){
                try {     
                    console.log(action,'***************');
                    if (action == "on_row_clicked") {
                         
                    }else if (action == "select_item") {
                         
                    }else if (action == "edit_item") {
                         
                    }else if (action == "update_item_measurement") {
                        this.ON_UPDATE_MEASUREMENT(item)
                    }else if (action == "remove_item_measurement") {
                        this.REMOVE_MEASUREMENT(item)
                    }else{}
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
           
            ON_ADD_ITEM_MEASUREMENT(){
                try { 
                    this.input = {}
                    this.dialog_add_measurement = true
                    this.field_updating = false
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_ADD_ITEM_MEASUREMENT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ADD_ITEM_MEASUREMENT(input){
                try {  
                    let mbs_text = this.MBS.text.item_action("Item Measurement","Add") 
                    const data = {
                        item_key : input?.item_key,
                        container_measuring_units_option_key : input?.container_measuring_units_option_key,
                        container_measuring_units_key : input?.container_measuring_units_key,
                        container_empty_size : input?.container_empty_size,
                        container_full_size : input?.container_full_size, 
                        container_child_number : input?.container_child_number, 
                        container_child_ratio : input?.container_child_ratio, 
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=UPDATE-ITEM-MEASUREMENT", 
                            data:data
                        } 
                    }) 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM_MEASUREMENT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            SUBMIT_ITEM_MEASUREMENT(data){
                try { 
                    const item_path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    const item_link = item_path+data?.item_key+"/" 
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Adding..."
                    })
                    const detailed_data = {
                        ...data
                    } 

                    this.$store.dispatch('fi_update',{    
                        action:DATA.ITEMS.ITEMS.values,
                        path:item_link, 
                        data:detailed_data,  
                    }).then(res=>{
                        console.log(res,'res.......');
                        console.log(item_link,'item_link.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Updated")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        this.dialog_add_measurement = false
                        this.dialog_update_measurement = false
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Updated")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })

                    console.log(data,'on ss.......................');
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_ITEM_MEASUREMENT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            
            
            ON_UPDATE_MEASUREMENT(item){
                try {   
                    this.input = {
                        ...item,
                        item_key:item?.key, 
                    }
                    this.dialog_update_measurement = true  
                    this.field_updating = true 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_UPDATE_MEASUREMENT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            UPDATE_MEASUREMENT(input){
                try { 
                    let mbs_text = this.MBS.text.item_action("Item Measurement","Update") 
                    const data = {
                        item_key : input?.item_key,
                        container_measuring_units_option_key : input?.container_measuring_units_option_key,
                        container_measuring_units_key : input?.container_measuring_units_key,
                        container_empty_size : input?.container_empty_size,
                        container_full_size : input?.container_full_size, 
                        container_child_number : input?.container_child_number, 
                        container_child_ratio : input?.container_child_ratio, 
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=UPDATE-ITEM-MEASUREMENT", 
                            data:data
                        } 
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'UPDATE_MEASUREMENT',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            REMOVE_MEASUREMENT(input){
                try { 
                    let mbs_text = this.MBS.text.item_action("Measurement","Delete") 
                    const data = {
                        item_key : input?.item_key,
                        container_measuring_units_option_key : null,
                        container_measuring_units_key : null,
                        container_empty_size :null,
                        container_full_size : null, 
                        container_child_number : null, 
                        container_child_ratio : null, 
                    }
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+"=UPDATE-ITEM-MEASUREMENT", 
                            data:data
                        } 
                    }) 
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'REMOVE_MEASUREMENT',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
          
            
            ADDED(res){
                try { 
                    this.RELOAD_ITEMS()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADDED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            RELOAD_ITEMS(){
                try {
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Refresh..."
                    })
                    this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.ITEMS.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    }).then(res=>{
                        console.log(res,'res.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },

            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=RELOAD-ITEMS') {
                            if (action.YES) {
                                this.RELOAD_ITEMS()
                            } else {
                                
                            }
                        } if (action.code ===PAGE_NAME+'=UPDATE-ITEM-MEASUREMENT') {
                            if (action.YES) {
                                this.SUBMIT_ITEM_MEASUREMENT(action?.data)
                            } else {
                                
                            }
                        } 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            if (!gettingItems) {
                                this.PAGE_LOAD =true
                            }  
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },  
        },
        beforeDestroy(){
            try { 
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch: {  
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            }, 
        },
    }
</script>
 
